import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignIn } from './sign-in/sign-in';
import { SignUp } from './sign-up/sign-up';
import { FirstTimePasswordChange } from './first-time-password-change/first-time-password-change';
import { AuthRoutingModule } from './auth-routing-module';
import { SharedModule } from '../shared/shared-module';

@NgModule({
  declarations: [
    SignIn,
    SignUp,
    FirstTimePasswordChange,

  ],
  imports: [
    CommonModule,
    SharedModule,
    AuthRoutingModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AuthModule { }
